import { Flag } from 'lucide-react'
import { useState } from 'react'

import { UrlParam, useUrlParams } from '@/lib/url/url-param.hook'

import { FalsePositiveModal } from '@/pages/alert-details/false-positive-modal'
import { FALSE_POSITIVE_LABEL, FALSE_POSITIVE_MODAL_TEXT } from '@/pages/alert-details/labels'

import { Button } from '@/components/lemmala-design-system/button/button'

type FalsePositiveProps = {
  signalId: string
  signalTitle: string
  companyName?: string
}

export const FalsePositive = ({ signalId, signalTitle, companyName }: FalsePositiveProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const { removeParam } = useUrlParams()

  const handleClose = () => {
    setIsModalOpen(false)
    removeParam(UrlParam.ALERT_ID)
    removeParam(UrlParam.SIGNAL_ID)
  }

  return (
    <>
      <Button onClick={() => setIsModalOpen(true)} variant='ghost' className='flex gap-1'>
        <Flag strokeWidth={1.5} className='size-4' />
        {FALSE_POSITIVE_LABEL}
      </Button>
      <FalsePositiveModal
        title={FALSE_POSITIVE_MODAL_TEXT.TITLE}
        isOpen={isModalOpen}
        onClose={(success) => {
          setIsModalOpen(false)
          if (success) {
            handleClose()
          }
        }}
        signalId={signalId}
        signalTitle={signalTitle}
        companyName={companyName}
      />
    </>
  )
}
